import React from 'react'
import { useLocation } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Routers from '../../routers/Routers';

const Layout = () => {
  const location = useLocation();
  const hideDefaultLayout = location.pathname === "/lp/galleria-private-office-offer";

  return (
    <>
      {!hideDefaultLayout && <Header />}
      <div>
        <Routers />
      </div>
      {!hideDefaultLayout && <Footer />}
    </>
  );
};

export default Layout;